// Canonical appointment types (5) + colors. Keep in sync with backend migration.
export const TIPO_META = {
  vendita: { label: "Vendita", color: "#EF4444" },
  acquisizione: { label: "Acquisizione", color: "#22C55E" },
  sopralluogo: { label: "Sopralluogo", color: "#FACC15" },
  acquirente: { label: "Acquirente", color: "#3B82F6" },
  riunione_soci: { label: "Riunione soci", color: "#14B8A6" },
  riunione_ufficio: { label: "Riunione d'ufficio", color: "#FC82ED" },
  bloccato: { label: "Agenda bloccata", color: "#111827" },
};
export const TIPO_ORDER = ["vendita", "acquisizione", "sopralluogo", "acquirente", "bloccato"];
export const SCADENZA_COLOR = "#9CA3AF";
export const DA_CLASSIFICARE_COLOR = "#9CA3AF";

// Types selectable when creating a normal appointment (block is created via its own flow).
export const TIPO_APPT_OPTS = [
  ["acquirente", "Acquirente (visita)"],
  ["vendita", "Vendita"],
  ["acquisizione", "Acquisizione"],
  ["sopralluogo", "Sopralluogo"],
];

export const tipoColor = (e) => {
  if (e.kind === "proposta_scadenza") return SCADENZA_COLOR;
  if (e.da_classificare) return DA_CLASSIFICARE_COLOR;
  const m = TIPO_META[e.tipo];
  return m ? m.color : DA_CLASSIFICARE_COLOR;
};

export const isLightColor = (hex) => {
  const c = String(hex || "").replace("#", "");
  if (c.length < 6) return false;
  const r = parseInt(c.substr(0, 2), 16), g = parseInt(c.substr(2, 2), 16), b = parseInt(c.substr(4, 2), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) > 150;
};

export const initialsOf = (name) =>
  (name || "").trim().split(/\s+/).slice(0, 2).map((p) => p[0] || "").join("").toUpperCase();
